interface ScholarshipsIconProps {
  className?: string;
}

export const ScholarshipsIcon = ({ className }: ScholarshipsIconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Mortarboard cap */}
    <path
      d="M10 2L1 6.5L10 11L19 6.5L10 2Z"
      fill="currentColor"
    />
    <path
      d="M4 8.75V13C4 13 6 15 10 15C14 15 16 13 16 13V8.75L10 11.75L4 8.75Z"
      fill="currentColor"
    />
    <path
      d="M17.5 7.5V12.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <circle cx="17.5" cy="13.5" r="0.8" fill="currentColor" />
  </svg>
);
